export * from "./micro";

import { ViewModelProto } from '../view/ViewModel';

ViewModelProto._stream = null;

//import { prop } from "../utils";
//mini.prop = prop;